var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeCouloir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.355 64.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 811",
    d: "m35.341 10.826-.518-.6a.736.736 0 0 1 .643-1.2h8.572a.741.741 0 0 1 .666 1.168l-.463.6a.827.827 0 0 1-.667.313h-7.59a.833.833 0 0 1-.643-.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 812",
    d: "m31.592 5.131-2.157-2.488a.736.736 0 0 1 .643-1.2h19.347a.741.741 0 0 1 .667 1.168l-1.937 2.492a.827.827 0 0 1-.667.313H32.227a.83.83 0 0 1-.635-.285Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 813",
    d: "M77.29 64.5a2.1 2.1 0 0 1-1.25-.409L64.621 55.64a1.939 1.939 0 0 1-.808-1.6V9.595a1.973 1.973 0 0 1 .882-1.635L76.113.36A2.1 2.1 0 0 1 77.28.007a2.034 2.034 0 0 1 2.07 1.991V62.52a1.951 1.951 0 0 1-.687 1.482 2.118 2.118 0 0 1-1.373.498ZM66.313 53.782l10.542 7.8V2.866l-10.542 7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 814",
    d: "M58.206 50.366a2 2 0 0 1-1.176-.38l-6.077-4.408a1.884 1.884 0 0 1-.746-1.474v-24.69a1.867 1.867 0 0 1 .844-1.543l.013-.008 6.045-3.95a1.992 1.992 0 0 1 1.1-.328 1.922 1.922 0 0 1 1.956 1.881v33.027a1.839 1.839 0 0 1-.665 1.411 2.017 2.017 0 0 1-1.294.462Zm-5.5-6.6 4.958 3.6V16.533l-4.958 3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 815",
    d: "M44.649 42.519h-9.913a2.005 2.005 0 0 1-2.066-1.934V22.403a2.005 2.005 0 0 1 2.066-1.934h9.913a2.005 2.005 0 0 1 2.066 1.934v18.183a2.005 2.005 0 0 1-2.066 1.933Zm-9.478-2.5h9.044v-17.05h-9.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 809",
    d: "M2.065 64.5A2.029 2.029 0 0 1 0 62.514V1.991A2.034 2.034 0 0 1 2.07 0a2.1 2.1 0 0 1 1.168.353L14.66 7.96a1.973 1.973 0 0 1 .882 1.635V54.04a1.939 1.939 0 0 1-.808 1.6L3.319 64.088a2.1 2.1 0 0 1-1.254.412ZM2.5 2.866v58.718l10.542-7.8v-43.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 810",
    d: "M21.149 50.366a1.921 1.921 0 0 1-1.959-1.877V15.466a1.922 1.922 0 0 1 1.958-1.879 1.992 1.992 0 0 1 1.1.328l6.057 3.958a1.867 1.867 0 0 1 .844 1.543v24.69a1.884 1.884 0 0 1-.746 1.474l-.029.022-6.046 4.386a2 2 0 0 1-1.179.378Zm.541-33.832v30.825l4.958-3.6V19.773Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeCouloir);
export default __webpack_public_path__ + "static/media/le-couloir.b628b0b84605b66cbb8ea67c5b2889ee.svg";
export { ForwardRef as ReactComponent };